import { useSelector } from "react-redux";
import { productCardCustomizations } from "src/data/staticData";
import useScrollOnMount from "src/hooks/App/useScrollOnMount";
import ProductCard from "../../shared/productcard/ProductCard/ProductCard";
import s from "./FavoriteProducts.module.scss";

const FavoriteProducts = () => {
  const { favoritesProducts } = useSelector((state) => state.products);
  useScrollOnMount(160);

  return (
    <div className={s.favProducts}>
      {favoritesProducts?.length > 0 ? (
        favoritesProducts.map((product) => (
          <ProductCard
            key={product.id}
            product={product}
            customization={productCardCustomizations.wishListProducts}
            removeFrom="favoritesProducts"
          />
        ))
      ) : (
        <h2>Not Available</h2>
      )}
    </div>
  );
};
export default FavoriteProducts;
